import { fetchTableData } from '@fifa-bsm/bo-frontend-shared/components/AppTable/fetchTableData';
import { BaseApiService } from '@/app/shared/services/apis/baseApi.service';
import { apiClient } from '@/app/core/services/apiClient.service';

const GUEST_OPERATIONS_SEAT_ALLOCATION_API_ROOT = 'seat-allocator/guest-operations';

class GuestOperationsSeatAllocationApi extends BaseApiService {
    getTickets(eventId, GOSeatPlanId, queryParams) {
        return this.client.get(
            `${GUEST_OPERATIONS_SEAT_ALLOCATION_API_ROOT}/allocation-list/events/${eventId}/tickets`,
            GOSeatPlanId ? { go_seat_plan_id: GOSeatPlanId, ...(queryParams ?? {}) } : undefined
        );
    }

    allocateSeats(eventId, seatPlanId, allocations, config) {
        return this.client.post(
            `${GUEST_OPERATIONS_SEAT_ALLOCATION_API_ROOT}/allocation-list/events/${eventId}/tickets/allocate`,
            {
                go_seat_plan_id: seatPlanId,
                allocations,
            },
            config
        );
    }

    removeAllocation(
        eventId,
        seatPlanId,
        { ticketId, undoDistribution = false, lastMinuteChanges = false }
    ) {
        return this.client.delete(
            `${GUEST_OPERATIONS_SEAT_ALLOCATION_API_ROOT}/allocation-list/events/${eventId}/tickets/${ticketId}`,
            {
                go_seat_plan_id: seatPlanId,
                undo_distribution: undoDistribution,
                last_minute_change: lastMinuteChanges,
            }
        );
    }

    swapSeats(eventId, seatPlanId, payload) {
        return this.client.patch(
            `${GUEST_OPERATIONS_SEAT_ALLOCATION_API_ROOT}/allocation-list/events/${eventId}/swap-seats`,
            { ...payload, go_seat_plan_id: seatPlanId }
        );
    }

    flashSeatTags(eventId, seatPlanId, payload) {
        return this.client.patch(
            `${GUEST_OPERATIONS_SEAT_ALLOCATION_API_ROOT}/allocation-list/events/${eventId}/flash-seats`,
            { ...payload, go_seat_plan_id: seatPlanId }
        );
    }

    generateTicketAndAllocateSeat(eventId, seatPlanId, payload) {
        return this.client.post(
            `${GUEST_OPERATIONS_SEAT_ALLOCATION_API_ROOT}/allocation-list/events/${eventId}/tickets/generate-and-allocate`,
            { ...payload, go_seat_plan_id: seatPlanId }
        );
    }

    setProtocolHeart(mainEventId, eventId, payload) {
        return this.client.patch(
            `main-events/${mainEventId}/events/${eventId}/seats/set-protocol-heart`,
            payload
        );
    }

    getSeatPlans(eventId) {
        return this.client.get(
            `${GUEST_OPERATIONS_SEAT_ALLOCATION_API_ROOT}/events/${eventId}/seat-plans`
        );
    }

    createSeatPlan(eventId) {
        return this.client.post(
            `${GUEST_OPERATIONS_SEAT_ALLOCATION_API_ROOT}/events/${eventId}/seat-plans`
        );
    }

    changePrimarySeatPlan(eventId, planId) {
        return this.client.post(
            `${GUEST_OPERATIONS_SEAT_ALLOCATION_API_ROOT}/events/${eventId}/seat-plans/change-official`,
            {
                go_seat_plan_id: planId,
            }
        );
    }
    removeSeatPlan(eventId, seatPlanId) {
        return this.client.delete(
            `${GUEST_OPERATIONS_SEAT_ALLOCATION_API_ROOT}/events/${eventId}/seat-plans/${seatPlanId}`
        );
    }
    importAllocationFromPrimaryPlan(eventId, targetPlanId) {
        return this.client.post(
            `${GUEST_OPERATIONS_SEAT_ALLOCATION_API_ROOT}/allocation-list/events/${eventId}/import-seat-allocations-to-seat-plan`,
            { go_seat_plan_id: targetPlanId }
        );
    }

    getMainEvents(params) {
        return this.client.get(`${GUEST_OPERATIONS_SEAT_ALLOCATION_API_ROOT}/main-events`, params);
    }

    getEventsForMainEvent(mainEventId, params) {
        return fetchTableData({
            ...params,
            url: `${GUEST_OPERATIONS_SEAT_ALLOCATION_API_ROOT}/main-events/${mainEventId}/events`,
        });
    }

    getLabelSettings(eventId) {
        return this.client.get(
            `${GUEST_OPERATIONS_SEAT_ALLOCATION_API_ROOT}/allocation-list/events/${eventId}/labels/filters`
        );
    }

    async printLabels(eventId, payload) {
        return this.client.post(
            `${GUEST_OPERATIONS_SEAT_ALLOCATION_API_ROOT}/allocation-list/events/${eventId}/labels/print`,
            payload,
            { responseType: 'arraybuffer' }
        );
    }

    async deallocateMultipleSeats(
        eventId,
        seatPlanId,
        { ticketIds, undoDistribution, lastMinuteChanges }
    ) {
        return this.client.delete(
            `${GUEST_OPERATIONS_SEAT_ALLOCATION_API_ROOT}/allocation-list/events/${eventId}/tickets/batch-deallocate`,
            {
                go_seat_plan_id: seatPlanId,
                tickets_ids: ticketIds,
                last_minute_change: lastMinuteChanges,
                undo_distribution: undoDistribution,
            }
        );
    }

    getEventListFilters(mainEventId) {
        return this.client.get(
            `${GUEST_OPERATIONS_SEAT_ALLOCATION_API_ROOT}/main-events/${mainEventId}/events/filters`
        );
    }
}

export const guestOperationsSeatAllocationApi = new GuestOperationsSeatAllocationApi(apiClient);
